/**
 * Ролик урока с Google Drive (техдолг 242, 17.09.2026).
 *
 * Ссылка «поделиться» (`drive.google.com/file/d/<id>/view`) отдаёт HTML-страницу, а не видео: в `<video src>`
 * ученик видел чёрный плеер 0:00, который не играет никогда. Играет только страница предпросмотра Drive
 * `…/file/d/<id>/preview` в рамке — её и строим. Доступ «по ссылке» у файла выставляет методист: закрытый
 * файл рамка покажет как «нет доступа», но это уже видно и понятно, а не немой чёрный экран.
 */

const FILE_PATH = /^\/file\/d\/([A-Za-z0-9_-]{10,})(?:\/|$)/;
const ID_PARAM = /^[A-Za-z0-9_-]{10,}$/;

/** Номер файла Drive из ссылки или null, если ссылка не на файл Drive. */
export function driveFileId(raw: string): string | null {
  let u: URL;
  try {
    u = new URL(raw.trim());
  } catch {
    return null;
  }
  if (u.hostname !== 'drive.google.com') return null;
  const m = u.pathname.match(FILE_PATH);
  if (m) return m[1];
  // Старые формы: /open?id=<id> и /uc?id=<id>.
  if (u.pathname === '/open' || u.pathname === '/uc') {
    const id = u.searchParams.get('id');
    return id && ID_PARAM.test(id) ? id : null;
  }
  return null;
}

/** Адрес рамки предпросмотра Drive для номера файла. */
export function drivePreviewUrl(id: string): string {
  return `https://drive.google.com/file/d/${encodeURIComponent(id)}/preview`;
}
